import router from "./router";
import store from "./store";
import { getToken, setToken, removeToken } from "@utils/auth";
import { GetQueryString, setPageTitle } from "@utils/other";
import Cookies from "js-cookie";
import NProgress from "nprogress"; // progress bar
import "nprogress/nprogress.css"; // progress bar style
// import * as dd from 'dingtalk-jsapi';
//进度条
NProgress.configure({ showSpinner: false });

// no redirect whitelist
const whiteList = [
    "/smileTestPC",
    "/smileTest",
    "/designconfirm-detail",
    "/winxinForm",
    "/signIn",
    "/register",
    "/forget-pwd",
    "/bind-account",
    "/bind-account/success",
    "/sales-wechat-binding",
    "/sales-wechat-binding/success",
    "/register-protocol",
    "/privacy-protocol",
    "/privacyPolicy",
    "/about-us",
    "/guide-cert",
    "/guide-cm",
    "/file-view/video",
    "/file-view/pdf",
    "/invite/invite-rule",
    "/app-privacy-protocol",
    "/app-register-protocol",
    "/privacy-protocol-en",
    "/register-protocol-en",
    "/login", //扫描注册页面
    "/scan-activity/investigation",
    "/scan-activity/success",
    "/privacyPolicyEn",
    "/organization-wechat-binding",
    "/organization-wechat-binding/success",
    "/app-pay-detail",
    "/testWeixin",
    "/online3-submit-info",
    "/online3-new-patient/preview",
    "/online3-adjust-patient/preview",
    "/online3-end-patient/preview",
    "/mobile-payment",
    "/app-popularize",
    "/online3/end-year/detail",
    "/mine/end-year/detail",
    "/end-year/detail",
    "/electronic-card",
    "/electronic-card-info",
    "/refinement-en",
    "/restart-en",
    "/privacyPolicy-android"
];

const dynamicWhiteList = [
    'app-market-case-bank'
    // 'app-pay-detail'
]

router.beforeEach((to, from, next) => {
    setPageTitle(to.meta.title)
    if (from.name === 'adviceTemplate') {
        to.meta.isBack = true
    }
    if (from.name === 'doctorAdvice') {
        to.meta.isBack = false
    }
    //app内嵌需登陆页面调用方法
    enterFromApp();
    NProgress.start(); // start progress bar
    const dynamicPathResult = dynamicWhiteList.some(item => {
      // const regWord = to.path.replaceAll('/', '\/')
      const reg = new RegExp(`/${item}/([\\s\\S]*)`)
      return reg.test(to.path)
    })
    if (whiteList.indexOf(to.path) !== -1 || dynamicPathResult) {
        // 在免登录白名单，直接进入
        if (dynamicPathResult) {
            if (to.meta.title) {
                document.title = to.meta.title
            }
        }
        next();
    } else if (getToken()) {
        // determine if there has token
        /* has token*/
        if (to.path === "/signIn") {
            next({ path: "/patient-manage" });
            NProgress.done(); // if current page is dashboard will not trigger	afterEach hook, so manually handle it
        } else {
            if ((!store.getters.hadAddRoutes)&&Cookies.get('isApp')==0) {
                // 判断当前用户是否已拉取完user_info信息
                store
                    .dispatch("GetUserInfo")
                    .then(res => {
                        // 拉取user_info
                        const roles = store.getters.roles;
                        store.dispatch("GenerateRoutes", { roles }).then(() => {
                            // 根据roles权限生成可访问的路由表
                            router.addRoutes(store.getters.addRouters); // 动态添加可访问路由表
                            if (store.getters.user.HospitalTextName == "") {
                                next({ path: "/basic-info", replace: true });
                            } else {
                                next({...to, replace: true }); // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
                            }
                        });
                    })
                    .catch(err => {
                        console.log(err);
                        setTimeout(() => {
                            next({ path: "/signIn", replace: true });
                        }, 3000);
                    });
            } else {
                Cookies.set("isApp",0)
                if (
                    store.getters.user.HospitalTextName == "" &&
                    to.path !== "/basic-info"
                ) {
                    next({ path: "/basic-info", replace: true });
                } else {
                    next(); // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
                }
            }
        }
    } else {
        next("/signIn"); // 否则全部重定向到登录页
        NProgress.done(); // if current page is login will not trigger afterEach hook, so manually handle it
    }
});

router.afterEach(() => {
    NProgress.done(); // finish progress bar
});

//app内嵌页面
function enterFromApp() {
    let token, uid, from;
    token = GetQueryString("token");
    uid = GetQueryString("uid");
    from = GetQueryString("from");
    let yearEndtype = GetQueryString("type") * 1;
    if (from == "android" || from == "ios") {
        localStorage.setItem("source", from);
        if (token && uid) {
            Cookies.set("token", token);
            Cookies.set("uid", uid);
            Cookies.set("isApp",1)
        }
    } else if(yearEndtype === 2) {
        if (token && uid) {
            Cookies.set("token", token);
            Cookies.set("uid", uid);
        }
    }else {
        localStorage.setItem("source", "");
    }
}


// WEBPACK FOOTER //
// ./src/permission.js